import BaseModelAPI from '../BaseModelAPI';

export default class PickingForDelivery extends BaseModelAPI {
	static entity = 'pickingfordelivery';
	static entityName = 'pickingfordelivery';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.pickingNumber = '';
			this.deliveryInstructionId = '';
			this.deliveryInstruction = {};
			this.pickingDate = '';
			this.startDate = '';
			this.finishDate = '';
			this.pickingByUserName = '';
			this.pickingBy = {};
			this.pickingStatusId = '';
			this.pickingStatus = {};
			this.pickingForDeliveryDetail = []
			this.pickingCardDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}
	static async getDeliveryInstuctionToPick(this_) {
        return this_.$http.get(`${this.entityName}/getDeliveryInstuctionToPick`)
        .then(response => {
            let responseData = response.data;
            return responseData;
        })
        .catch(function(error){
            this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
        });;
    }

}